module.exports = __webpack_public_path__ + "static/img/03.e47364a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/05/03.jpg
// module id = KjlV
// module chunks = 0